<template>
  <div class="container-fluid">
    <div class="jobs-types mt-4">
      <!-- <div class="jobs-types-header d-flex">
        <div>
          <h3 class="mb-0 mt-2">المهن</h3>
        </div>
        <div class="mt-2">
          <el-button @click="openJobModel = true"> إضافة </el-button>
        </div>
      </div> -->
      <h3 class="mb-3">المهن</h3>
      <div class="locations__header d-flex">
        <div style="flex: 1">
          <el-input

            @input="searchInJobs"
            prefix-icon="el-icon-search"
            placeholder="بحث في المهن"
            v-model="search"
          ></el-input>
        </div>
        <div>
          <el-button type="primary" @click="openJobModel = true">
            إضافة
          </el-button>
        </div>
      </div>

      <div class="mt-2 row" v-if="jobs.length > 0">
        <div class="col-md-3" v-for="job in jobs" :key="job.id">
          <div class="job-card mb-2">
            <div class="d-flex justify-content-between align-center">
              <div>
                <h4>{{ job.name }}</h4>
              </div>
              <div class="locations__actions">
                <div class="actions">
                  <div>
                    <button
                      @click="(updateJobModel = true), (currJob = { ...job })"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Icon"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <rect
                          id="Area"
                          width="20"
                          height="20"
                          fill="#fcfcfc"
                          opacity="0"
                        />
                        <g
                          id="Icon-2"
                          data-name="Icon"
                          transform="translate(1.566 1.566)"
                        >
                          <path
                            id="Path"
                            d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                            transform="translate(0.101 -1.566)"
                            fill="none"
                            stroke="#919efa"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.667"
                          />
                          <path
                            id="Path-2"
                            data-name="Path"
                            d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                            transform="translate(-6.667 -1.566)"
                            fill="none"
                            stroke="#919efa"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.667"
                          />
                        </g>
                      </svg>
                    </button>
                  </div>

                  <!-- <div>
                    <el-popconfirm
                      :title="'هل أنت متأكد من الحذف ؟'"
                      :cancel-button-text="'إلغاء'"
                      :confirm-button-text="'حذف'"
                    >
                      <button slot="reference">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Icon"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <rect
                            id="Area"
                            width="20"
                            height="20"
                            fill="#fcfcfc"
                            opacity="0"
                          />
                          <g
                            id="Icon-2"
                            data-name="Icon"
                            transform="translate(2.5 1.667)"
                          >
                            <path
                              id="Path"
                              d="M17.5,5H2.5"
                              transform="translate(-2.5 -1.667)"
                              fill="none"
                              stroke="red"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                            <path
                              id="Path-2"
                              data-name="Path"
                              d="M4.167,5V16.667a1.666,1.666,0,0,0,1.666,1.666h8.334a1.666,1.666,0,0,0,1.666-1.666V5m-2.5,0V3.333a1.666,1.666,0,0,0-1.666-1.666H8.333A1.666,1.666,0,0,0,6.667,3.333V5"
                              transform="translate(-2.5 -1.667)"
                              fill="none"
                              stroke="red"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                            <line
                              id="Line"
                              y2="5"
                              transform="translate(9.167 7.5)"
                              fill="none"
                              stroke="red"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                            <line
                              id="Line-2"
                              data-name="Line"
                              y2="5"
                              transform="translate(5.833 7.5)"
                              fill="none"
                              stroke="red"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                          </g>
                        </svg>
                      </button>
                    </el-popconfirm>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="no-data-img" v-else>
        <NoData />
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title="إضافة مهنة جديدة"
      :active.sync="openJobModel"
    >
      <div class="popup-calender">
        <el-form :model="addJob" ref="addJob">
          <h6 class="mb-1">اسم المهنة</h6>
          <el-form-item
            style="min-width: 300px"
            prop="name"
            :rules="[{ required: true, message: 'المهنة مطلوبة' }]"
          >
            <el-input 
            @keyup.enter="onSubmit('addJob')"
            placeholder="المهنة" v-model="addJob.name"></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmit('addJob')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

    <vs-popup
      class="popup-width-300"
      title="تعديل مهنة "
      :active.sync="updateJobModel"
    >
      <div class="popup-calender">
        <el-form :model="currJob" ref="updateJob">
          <h6 class="mb-1">اسم المهنة</h6>
          <el-form-item
            style="min-width: 300px"
            prop="name"
            :rules="[{ required: true, message: 'المهنة مطلوبة' }]"
          >
            <el-input
              @keyup.enter="onSubmit('updateJob')"
             placeholder="المهنة" v-model="currJob.name"></el-input>
          </el-form-item>

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmitUpdateJob('updateJob')">
                  حفظ التعديلات
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
import NoData from "@/components/NoData.vue";
export default {
  components: { NoData },
  created() {
    this.getJobsTypes();
  },
  data() {
    return {
      currJob: {},
      jobs: [],
      openJobModel: false,
      updateJobModel: false,
      addJob: {},
      search: "",
      allJobs: "",
    };
  },
  methods: {
    searchInJobs() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: false,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255,255,255,.7)",
      //   customClass: "fullscreen-loading",
      // });
      this.jobs = this.allJobs.filter((ele) => {
        return ele.name.includes(this.search);
      });
      // loading.close();
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post(`/jobs`, { ...this.addJob })
            .then(() => {
              this.addJob = {};
              this.openJobModel = false;
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.getJobsTypes();
            })
            .catch((err) => {
              if (err.response.status == 422) {
                this.$vs.notify({
                  title: "حدث خطأ!",
                  position: "top-center",
                  color: "danger",
                  text: "هذه المحافظة موجودة من قبل",
                });
              }
              if (err.response.status == 400) {
                this.$vs.notify({
                  title: "هذا المهنة موجودة من قبل",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },

    onSubmitUpdateJob(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .put(`/jobs/${this.currJob.id}`, { ...this.currJob })
            .then(() => {
              this.currJob = {};
              this.updateJobModel = false;
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.getJobsTypes();
            })
            .catch((err) => {
              if (err.response.status == 422) {
                this.$vs.notify({
                  title: "حدث خطأ!",
                  position: "top-center",
                  color: "danger",
                  text: "هذه المحافظة موجودة من قبل",
                });
              }
              if (err.response.status == 400) {
                this.$vs.notify({
                  title: "هذا المهنة موجودة من قبل",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },

    getJobsTypes() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/jobs`)
        .then((res) => {
          this.jobs = res.data;
          this.allJobs = res.data;
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style lang="scss">
.jobs-types {
  padding: 10px;
  .jobs-types-header {
    justify-content: space-between;
  }
  .job-card {
    padding: 10px;
    background: #fff;
  }
}
</style>